<template>
  <div class="layout--full bg-light">
    <router-view />
  </div>
</template>
<script>


export default {
  name: 'Full',
  components: {
   // HelloWorld,
  },
  data() {
    return {

    }
  },
computed: {

},
  firebase: {

  },
  methods: {

  }
}
</script>
<style>

</style>
